import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import Articles from "./pages/articles";
import { Recipes } from "./pages/recipes";
import { Aliments } from "./pages/aliments";
import { Videos } from "./pages/videos";
import { Users } from "./pages/users";
import { AuthLayout, SecuredApp } from "./context/auth";
import { Login } from "./pages/login";
import { DietDiagram } from "./pages/dietDiagram";
import { DiagramSvgForm } from "./pages/dietDiagram/diagramSvgForm";
import { LegendProvider } from "./context/legend";
import { EatmeManagement } from "./pages/eatmeManagement";
import { Stats } from "./pages/stats";
import { Nutritionists } from "./pages/nutritionists";
import { StatusProvider } from "./context/status";
import { Logs } from "./pages/logs";
import { Admins } from "./pages/admins";
import { MyAccount } from "./pages/myAccount";
import Consultation from "./pages/consultation";
import UserDetails from "./pages/users/userDetails";
import { ConfirmUser } from "./pages/confirmUser";
import { Podcasts } from "./pages/podcasts";
import { Products } from "./pages/products";
import { Orders } from "./pages/orders";
import VideoCallPage from "./pages/consultation/videocall";
import API from "./api/api"
import { MiCuenta } from "./pages/myAccount/miCuenta";
import { MisDatos } from "./pages/myAccount/misDatos";
import { MiDisponibilidad } from "./pages/myAccount/miDisponibilidad";
import { DevUtils, TestUploadImage } from "./pages/_alreylz/DevUtils";
const root = ReactDOM.createRoot(document.getElementById("root"));
// const basename = document.querySelector("base")?.getAttribute("href") ?? "/";

const basename=  "/react"

root.render(
  /*<React.StrictMode>*/
  <SecuredApp> 
    <LegendProvider>
      <StatusProvider>
        <Router basename={basename}>
          <Routes>
            <Route element={<AuthLayout />}>
              <Route exact path="/aliments" element={<Aliments />} />
              <Route exact path="/articles" element={<Articles />} />
              <Route exact path="/recipes" element={<Recipes />} />
              <Route
                exact
                path="/users"
                element={<Users />}
                handle={{
                  // you can put whatever you want on a route handle
                  // here we use "crumb" and return some elements,
                  // this is what we'll render in the breadcrumbs
                  // for this route
                  crumb: (data) => <Link to="/users">Users</Link>,
                }}
              />
              <Route exact path="/users/:id" element={<UserDetails />} />
              <Route exact path="/videos" element={<Videos />} />
              <Route exact path="/management" element={<EatmeManagement />} />
              <Route exact path="/dietDiagram" element={<DietDiagram />} />
              <Route
                exact
                path="/dietDiagramSvg"
                element={<DiagramSvgForm />}
              />
              <Route exact path="/nutritionists" element={<Nutritionists />} />
              <Route exact path="/consultation" element={<Consultation />} />
              <Route
                exact
                path="/consultation/:id"
                element={<VideoCallPage />}
              />
              <Route exact path="/myAccount" element={<MyAccount />} />
              <Route exact path="/admins" element={<Admins />} />
              <Route exact path="/devUtils" element={<DevUtils />} />
              <Route exact path="/stats" element={<Stats />} />
              <Route exact path="/logs" element={<Logs />} />
              <Route path="/" element={<Navigate to="/articles" />} />
            </Route>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/confirmEmail/:id" element={<ConfirmUser />} />
            <Route exact path="/podcasts" element={<Podcasts />} />
            <Route exact path="/products" element={<Products />} />
            <Route exact path="/orders" element={<Orders />} />

            <Route exact path="/nutritionist/misDatos"   element={<MisDatos/>}/>
            <Route exact path="/nutritionist/miCuenta"   element={<MiCuenta/>}/>
            <Route exact path="/nutritionist/miDisponibilidad"   element={<MiDisponibilidad/>}/>
          


            {/*<Navigate exact to='/404'/>*/}
          </Routes>
        </Router>
      </StatusProvider>
    </LegendProvider>
  </SecuredApp>
  /*</React.StrictMode>*/
);
